/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'to-top': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<path pid="0" d="M29.5.6c.6 0 1 .4 1 1s-.4 1-1 1h-25c-.6 0-1-.4-1-1s.4-1 1-1h25zM17.5 10.2v22.2c0 .6-.4 1-1 1s-1-.4-1-1V10l-6.4 6.3c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4L15.6 7c.2-.2.5-.3.7-.3.3 0 .5.1.7.3l8 8c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-6.1-6.2z"/>'
  }
})
